import React from 'react';
import './Table.scss';

function Table({
    headers,
    body
}) {

    return <table className="field-table">
        <thead>
            <tr>
                {headers.map((f, i) => <th key={i}>{f}</th>)}
            </tr>
        </thead>
        <tbody>
            {body.map((row, i) =>
                <tr key={i}>
                    {row.map((f, i) => <td key={i}>{f}</td>)}
                </tr>
            )}
        </tbody>
    </table>
}

export default Table;
